/*
Light / dark theme toggle.

Convention: the active theme is stored in the `data-theme` attribute on the
<html> element ("light" | "dark"). The no-flash inline script in default.hbs
sets this before first paint. This module wires up the header toggle button
(#permet-theme-toggle), persists the user's choice in localStorage under the
`permet-theme` key, and keeps following the OS preference until the user makes
an explicit choice.
*/

const STORAGE_KEY = 'permet-theme';

function systemPrefersDark() {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
}

function getStored() {
    try {
        const v = localStorage.getItem(STORAGE_KEY);
        return v === 'dark' || v === 'light' ? v : null;
    } catch (e) {
        return null;
    }
}

function currentTheme() {
    return document.documentElement.getAttribute('data-theme')
        || getStored()
        || (systemPrefersDark() ? 'dark' : 'light');
}

function applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    const btn = document.getElementById('permet-theme-toggle');
    if (btn) {
        btn.setAttribute('aria-pressed', String(theme === 'dark'));
    }
}

export default function themeToggle() {
    // Reflect the current state on the button straight away.
    applyTheme(currentTheme());

    const btn = document.getElementById('permet-theme-toggle');
    if (btn) {
        btn.addEventListener('click', () => {
            const next = currentTheme() === 'dark' ? 'light' : 'dark';
            try {
                localStorage.setItem(STORAGE_KEY, next);
            } catch (e) {}
            applyTheme(next);
        });
    }

    // Follow OS changes only while the user hasn't picked a theme manually.
    if (window.matchMedia) {
        const mq = window.matchMedia('(prefers-color-scheme: dark)');
        const onChange = (e) => {
            if (getStored()) { return; }
            applyTheme(e.matches ? 'dark' : 'light');
        };
        if (mq.addEventListener) {
            mq.addEventListener('change', onChange);
        } else if (mq.addListener) {
            mq.addListener(onChange);
        }
    }
}
